<input
  class="text-input"
  type="text"
  autocomplete="off"
  [class.review-input-error-border]="error"
  [attr.id]="controlId"
  [attr.maxlength]="maxLength"
  [maskito]="maskOptions"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)" />
<span class="char-count" *ngIf="maxLength">{{ (value ?? '').length }}/{{ maxLength }}</span>
